import { render, staticRenderFns } from "./myNotes.vue?vue&type=template&id=e19d62a2"
import script from "./myNotes.vue?vue&type=script&lang=js"
export * from "./myNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports